import { Box } from '@mui/material'
import FormError from '~/src/components/error/FormError'
import { FormikProps, useFormik } from 'formik'
import * as yup from 'yup'
import { useTranslations } from '~/src/hooks/useTranslations'
import ResetPasswordFormFields from '~/src/components/auth/reset-password/ResetPasswordFormFields'
import ResetPasswordFormActions from '~/src/components/auth/reset-password/ResetPasswordFormActions'
import { ResetPasswordFormInterface } from '~/src/types/forms/ResetPasswordFormInterface'
import { useEffect } from 'react'
import AUTHENTICATION_FLOW_STATE, { AuthenticationFlowState } from '~/src/stores/authentication-flow'
import { useEoState } from '~/src/hooks/useEoState'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'

interface Props {
  fieldsColor?: 'container' | 'content',
}

const ResetPasswordForm = ({ fieldsColor = 'content' }: Props) => {
  const { next } = useAuthenticationFlowDialogs()
  const { t } = useTranslations()
  const [ authenticationFlowState ,setAuthenticationFlowState ] = useEoState<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)
  const formik: FormikProps<ResetPasswordFormInterface> = useFormik<ResetPasswordFormInterface>({
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: yup.object({
      password: yup
        .string()
        .required(t('errors.passwordRequired')),
      confirmPassword: yup
        .string()
        .oneOf([ yup.ref('password') ], t('errors.passwordMismatch'))
        .required(t('errors.passwordRequired'))
    }),
    onSubmit: () => {
      next()
    }
  })

  useEffect(() => {
    setAuthenticationFlowState((state: AuthenticationFlowState) => ({
      ...state,
      password: formik.values.password,
      confirmPassword: formik.values.confirmPassword
    }))
  }, [ formik.values ])

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {authenticationFlowState.errors && <FormError errors={authenticationFlowState.errors}/>}

        <ResetPasswordFormFields
          form={formik}
          fieldsColor={fieldsColor}/>

        <ResetPasswordFormActions
          form={formik}
          loading={authenticationFlowState.isLoading}
        />
      </Box>
    </form>
  )
}

export default ResetPasswordForm
